export type CompanyDetailType = 'vehicle_controller' | 'driver'

export type GetCompanyDetailEndpointParams = {
  tenantId: string
  warehouseId: string
  companyId: string
  type: CompanyDetailType
}

export const getCompanyDetailEndpoint = (params: GetCompanyDetailEndpointParams): string => {
  const query = new URLSearchParams({
    tenant_id: params.tenantId,
    warehouse_id: params.warehouseId,
    company_id: params.companyId,
    type: params.type,
  })
  return `/berths/booking/company/detail?${query.toString()}` as const
}
